import React, { Component, PropTypes } from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import MomentLocaleUtils from 'react-day-picker/moment';
import moment from 'moment';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';

function getDropDownText(state, props, defaultText = 'Période', format = 'll') {
    const { preset } = state;

    if (null !== preset) {
        return DateRangePickerContainer.presets[preset].label;
    }

    const from = null !== props.from ? moment(props.from) : null;
    const to = null !== props.to ? moment(props.to) : null;

    if (null == from && null == to) {
        return defaultText;
    }

    if (null !== from && null == to) {
        return from.format(format);
    }

    if (null == from && null !== to) {
        return to.format(format);
    }

    if (to.isSame(from, 'day')) {
        return from.format(format);
    } else {
        return from.format(format) + '-' + to.format(format);
    }
}

export default class DateRangePickerContainer extends Component {
    static propTypes = {
        from:          PropTypes.string,
        to:            PropTypes.string,
        onSubmit:      PropTypes.func.isRequired,
        locale:        PropTypes.string,
        options:       PropTypes.array,
        selectedOptions:       PropTypes.object
    };

    static defaultProps = {
        from: null,
        to:   null,
        locale: "fr",
        options: [],
        selectedOptions: {},
    };

    state = {
        showPicker: false,
        range: {
            from: this.props.from,
            to:   this.props.to
        },
        preset: null,
        selectedOptions: {},
        pickerValue: ""
    };

    static presets = {
        "this-month": {
            label: 'Ce mois-ci',
            range: {
                from: moment().toDate(),
                to: moment().endOf('month').toDate()
            }
        },
        "last-month": {
            label: 'Le mois prochain',
            range: {
                from: moment().add(1, 'months').startOf('month').toDate(),
                to: moment().add(1, 'months').endOf('month').toDate()
            }
        }
    };

    componentDidUpdate(prevProps) {
        if(prevProps.from == null && prevProps.to == null
        && this.props.from != null && this.props.to != null){
            this.setState({ range: {from: moment(this.props.from).toDate(), to: moment(this.props.to).toDate()} }, ()=>{
                this.resolvePreset();
            });
        }
    }

    componentDidMount() {
        this.resolvePreset();
        this.setState({selectedOptions: this.props.selectedOptions});
    }

    handleClickDropdown(e) {
        e.preventDefault();
        this.togglePicker();
    }

    togglePicker() {
        this.setState({ showPicker: !this.state.showPicker });
    }

    resolvePreset() {
        const { from, to } = this.state.range;

        if (null == from || null == to) {
            return;
        }

        const presets = DateRangePickerContainer.presets;
        const stateFrom = moment(from);
        const fromTo   = moment(to);
        let currentPreset = null;

        Object.keys(presets).forEach(id => {
            const preset = presets[id];
            const presetFrom = moment(preset.range.from);
            const presetTo = moment(preset.range.to);

            if (presetFrom.format('YYYY-MM-DD') == stateFrom.format('YYYY-MM-DD')
                && presetTo.format('YYYY-MM-DD') == fromTo.format('YYYY-MM-DD')) {
                currentPreset = id;
            }
        });

        this.setState({
            preset: currentPreset,
            pickerValue : currentPreset ? DateRangePickerContainer.presets[currentPreset].label : 'Du '+stateFrom.format('DD/MM/YYYY')+ ' au ' +  fromTo.format('DD/MM/YYYY')}
        );
    }

    handleDayClick(e, day) {
        const range = DateUtils.addDayToRange(day, this.state.range);
        this.setState({ range: range });
    }

    handleSubmit(e) {
        e.preventDefault();

        const { range } = this.state;

        if (null == range.to) {
            return this.setState({
                range: {
                    ...range,
                    to: range.from
                }
            }, this.submit);
        }

        this.submit();
    }

    submit() {
        const { range, selectedOptions } = this.state;

        let from = range.from ? moment(range.from).startOf('day'): null;
        let to = range.to ? moment(range.to).endOf('day') : null;

        this.props.onSubmit({
            from: from.toDate() ,
            to: to.toDate() ,
            options: selectedOptions
        });

        this.resolvePreset();
        this.togglePicker();
    }

    handlePresetClick(id, e) {
        e.preventDefault();
        this.setState({ range: DateRangePickerContainer.presets[id].range }, this.submit);
    }

    handleOnClickOption(event){
        const target = event.target;
        let selectedOptions = this.state.selectedOptions;
        if(selectedOptions[target.name]){
            delete selectedOptions[target.name];
        } else {
            selectedOptions[target.name] = target.value;
        }
        this.setState({ selectedOptions: selectedOptions });
    }

    render() {
        return (
            <div className="date-range-filter">
                {this.renderDropDown()}
                {this.renderPicker()}
            </div>
        );
    }

    renderDropDown() {
        const {pickerValue} = this.state;

        return (
        <div className="input-group">
            <input onClick={this.handleClickDropdown.bind(this)}
                ref="input"
                className="form-control"
                autoComplete="off"
               value={pickerValue}
            />
            <span className="input-group-btn">
                        <button className="btn btn-default" type="button" onClick={this.handleClickDropdown.bind(this)}>
                            <i className="fal fa-calendar"/>
                        </button>
                    </span>
        </div>
        );
    }

    renderPicker() {
        if (!this.state.showPicker) {
            return null;
        }
        const { options } = this.props;
        const { range, selectedOptions } = this.state;
        const modifiers = {
            selected: day => DateUtils.isDayInRange(day, range)
        };
        const initialMonth = null !== range.from ? range.from : moment().toDate();

        return (
            <div className="picker-content">
                <div className="picker">
                    <DayPicker
                        ref="daypicker"
                        locale={this.props.locale}
                        localeUtils={MomentLocaleUtils}
                        numberOfMonths={ 2 }
                        initialMonth={initialMonth}
                        modifiers={ modifiers }
                        disabledDays={day => DateUtils.isPastDay(day)}
                        onDayClick={ this.handleDayClick.bind(this) }
                    />
                </div>

                {!isEmpty(options) && <div className="picker-content-options">{options.map((option, index) =>(
                    <label key={index}><input onChange={this.handleOnClickOption.bind(this)} type="checkbox" checked={selectedOptions[option.name]} value={option.value} name={option.name}/>{option.label}</label>
                )) }</div>}

                <div className="presets">
                    {this.renderPresets()}
                </div>

                <div className="actions text-center">
                    <a href="#" className="btn btn-primary" onClick={this.handleSubmit.bind(this)}>
                        <i className="fa fa-check" /> Valider
                    </a>
                </div>
            </div>
        );
    }

    renderPresets() {
        const presets = DateRangePickerContainer.presets;

        const presetKeys = Object.keys(presets);
        const presetCount = presetKeys.length;
        let i = 0;

        return presetKeys.map(id => {
            i++;
            const preset = presets[id];
            const ClassName = cx("preset", id, {
                active: id == this.state.preset
            });

            return (
                <span key={id} className={ClassName}>
                    <a href="#" onClick={this.handlePresetClick.bind(this, id)}>
                        {preset.label}
                    </a>
                    {i < presetCount ? <span className="sep"> | </span> : ''}
                </span>
            );
        }, this);
    }

}